/** Which Settings sections a practice sees (see useSettingsSections): only those for modules switched on for it. */
export interface SettingsSections {
  loading: boolean;
  calls: boolean;
  insurance: boolean;
  operations: boolean;
  /** The practice management system the practice runs on (Oryx), a section of Operations. */
  practiceManagement: boolean;
  texting: boolean;
  callSettings: boolean;
  communication: boolean;
  community: boolean;
}

/** The Settings pages a practice sees, in menu order. */
export function settingsLinks(sections: Pick<SettingsSections, 'operations' | 'communication'>) {
  return [
    { label: 'Practice & Locations', path: '/settings/practice' },
    { label: 'Team & Staff', path: '/settings/team' },
    { label: 'Paid', path: '/settings/paid' },
    { label: 'Organic & Offline', path: '/settings/organic' },
    ...(sections.operations ? [{ label: 'Operations', path: '/settings/operations' }] : []),
    ...(sections.communication
      ? [{ label: 'Communication', path: '/settings/communication' }]
      : []),
  ];
}
